module.exports = __webpack_public_path__ + "static/media/supplier.7ffac3e1.png";